import { useMemo } from 'react';
import Select, { SelectProps } from 'components/molecules/Select';
import { generateTimeOptions } from 'utils/selectOptions';
import { isString } from 'utils/common';

export interface TimeSelectProps extends SelectProps {
  generateOptions?: Parameters<typeof generateTimeOptions>[0];
  value?: any;
}

function TimeSelect({ generateOptions, value, ...rest }: TimeSelectProps) {
  const timeOptions = useMemo(() => generateTimeOptions(generateOptions), []);
  const val = isString(value) ? timeOptions.find((t) => value === t.value) : value;

  return <Select {...rest} options={timeOptions} value={val} />;
}

export default TimeSelect;
